"use strict";

// =====================================================
// IGSS
//
// Archivo:
// src/fronend/Egresos/igss/igss.js
//
// FECHA DE PAGO:
// -----------------------------------------------------
// El input de fecha se muestra autom�ticamente con
// la fecha actual.
//
// IMPORTANTE:
// La fecha NO se env�a desde JavaScript al guardar.
//
// SQL SERVER registra autom�ticamente:
//
// GETDATE()
//
// en la columna FECHA.
//
// IMPORTANTE PARA MOSTRAR LA FECHA:
// -----------------------------------------------------
// NO utilizar:
//
// new Date(fecha)
//
// para mostrar FECHA de SQL Server.
//
// Esto puede provocar diferencias de d�a por zona
// horaria.
//
// La fecha se toma directamente desde:
//
// YYYY-MM-DD
//
// y se muestra como:
//
// DD/MM/YYYY
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosigss = [];

let registrosTablaIGSS = [];

let moduloIGSSInicializado = false;

let empleadoSeleccionadoIGSS = null;

let guardandoIGSS = false;

let eliminandoIGSS = false;


// =====================================================
// PORCENTAJE IGSS
// =====================================================

const PORCENTAJE_IGSS = 4.83;


// =====================================================
// ELEMENTOS DEL DOM
// =====================================================

let selectEmpleadoIGSS = null;

let idEmpleadoIGSS = null;

let nombreEmpleadoIGSS = null;

let dpiIGSS = null;

let nombrePuestoIGSS = null;

let direccionIGSS = null;

let salarioBaseIGSS = null;

let porcentajeIGSS = null;

let sueldoPagadoIGSS = null;

let fechaIGSS = null;


// =====================================================
// ELEMENTOS TABLA
// =====================================================

let tbodyIGSS = null;

let buscarIGSS = null;


// =====================================================
// OBTENER FECHA ACTUAL
// =====================================================
//
// input type="date" necesita:
//
// YYYY-MM-DD
//
// Ejemplo:
//
// 2026-10-03
//
// NO utilizar toISOString().
// =====================================================

function obtenerFechaActualIGSS() {

    const hoy =
        new Date();


    const anio =
        hoy.getFullYear();


    const mes =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            "0"
        );


    const dia =
        String(
            hoy.getDate()
        ).padStart(
            2,
            "0"
        );


    return `${anio}-${mes}-${dia}`;

}


// =====================================================
// COLOCAR FECHA ACTUAL EN INPUT
// =====================================================

function colocarFechaActualIGSS() {

    if (!fechaIGSS) {

        return;

    }


    fechaIGSS.value =
        obtenerFechaActualIGSS();

}


// =====================================================
// INICIALIZAR M�DULO
// =====================================================

async function inicializarIGSS() {

    if (moduloIGSSInicializado) {

        return;

    }


    // =================================================
    // DROPDOWN
    // =================================================

    selectEmpleadoIGSS =
        document.getElementById(
            "idEmpleadoIGSS"
        );


    // =================================================
    // INPUTS
    // =================================================

    idEmpleadoIGSS =
        document.getElementById(
            "mostrarIdEmpleadoIGSS"
        );


    nombreEmpleadoIGSS =
        document.getElementById(
            "nombreEmpleadoIGSS"
        );


    dpiIGSS =
        document.getElementById(
            "dpiEmpleadoIGSS"
        );


    nombrePuestoIGSS =
        document.getElementById(
            "puestoEmpleadoIGSS"
        );


    direccionIGSS =
        document.getElementById(
            "direccionEmpleadoIGSS"
        );


    salarioBaseIGSS =
        document.getElementById(
            "salarioBaseIGSS"
        );


    // =================================================
    // PORCENTAJE
    // =================================================

    porcentajeIGSS =
        document.getElementById(
            "porcentajeIGSS"
        );


    // =================================================
    // SUELDO PAGADO
    // =================================================

    sueldoPagadoIGSS =
        document.getElementById(
            "sueldoPagadoIGSS"
        );


    // =================================================
    // FECHA DE PAGO
    // =================================================

    fechaIGSS =
        document.getElementById(
            "fechaIGSS"
        );


    // =================================================
    // DETECTAR FECHA AUTOM�TICAMENTE
    // =================================================

    colocarFechaActualIGSS();


    // =================================================
    // TABLA
    // =================================================

    tbodyIGSS =
        document.getElementById(
            "tbodyIGSS"
        );


    // =================================================
    // BUSCADOR
    // =================================================

    buscarIGSS =
        document.getElementById(
            "buscarIGSS"
        );


    // =================================================
    // MOSTRAR 4.83
    // =================================================

    if (porcentajeIGSS) {

        porcentajeIGSS.value =
            PORCENTAJE_IGSS.toFixed(2);

    }


    // =================================================
    // EVENTO DROPDOWN
    // =================================================

    if (selectEmpleadoIGSS) {

        selectEmpleadoIGSS.addEventListener(
            "change",
            seleccionarEmpleadoIGSS
        );

    }


    // =================================================
    // EVENTO BUSCADOR
    // =================================================

    if (buscarIGSS) {

        buscarIGSS.addEventListener(
            "input",
            filtrarTablaIGSS
        );

    }


    // =================================================
    // BOT�N LIMPIAR B�SQUEDA
    // =================================================

    const btnLimpiarBusqueda =
        document.getElementById(
            "btnLimpiarBusqueda"
        );


    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            function () {

                if (buscarIGSS) {

                    buscarIGSS.value = "";

                }


                mostrarRegistrosIGSS(
                    registrosTablaIGSS
                );

            }
        );

    }


    // =================================================
    // MARCAR INICIALIZADO
    // =================================================

    moduloIGSSInicializado = true;


    // =================================================
    // CARGAR EMPLEADOS
    // =================================================

    await cargarEmpleadosIGSS();


    // =================================================
    // CARGAR TABLA
    // =================================================

    await cargarRegistrosIGSS();

}


// =====================================================
// CARGAR EMPLEADOS
//
// GET /igss
// =====================================================

async function cargarEmpleadosIGSS() {

    try {

        if (!selectEmpleadoIGSS) {

            console.warn(
                "No existe #idEmpleadoIGSS"
            );

            return;

        }


        selectEmpleadoIGSS.innerHTML = `
            <option value="">
                Cargando empleados...
            </option>
        `;


        selectEmpleadoIGSS.disabled = true;


        const respuesta =
            await fetch(
                "/igss"
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "RESPUESTA GET /igss:",
            resultado
        );


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudieron cargar los empleados"
            );

        }


        registrosigss =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        selectEmpleadoIGSS.innerHTML = "";


        const opcionInicial =
            document.createElement(
                "option"
            );


        opcionInicial.value = "";


        opcionInicial.textContent =
            "Seleccione un empleado...";


        selectEmpleadoIGSS.appendChild(
            opcionInicial
        );


        if (
            registrosigss.length === 0
        ) {

            const opcionVacia =
                document.createElement(
                    "option"
                );


            opcionVacia.value = "";


            opcionVacia.textContent =
                "No hay empleados disponibles";


            selectEmpleadoIGSS.appendChild(
                opcionVacia
            );


            selectEmpleadoIGSS.disabled =
                false;


            return;

        }


        registrosigss.forEach(
            empleado => {

                const option =
                    document.createElement(
                        "option"
                    );


                option.value =
                    empleado.IDEMPLEADO;


                option.textContent =
                    `${empleado.IDEMPLEADO} - ${empleado.NOMBREEMPLEADO}`;


                selectEmpleadoIGSS.appendChild(
                    option
                );

            }
        );


        selectEmpleadoIGSS.disabled =
            false;


    } catch (error) {

        console.error(
            "ERROR AL CARGAR EMPLEADOS IGSS:",
            error
        );


        if (selectEmpleadoIGSS) {

            selectEmpleadoIGSS.innerHTML = `
                <option value="">
                    Error al cargar empleados
                </option>
            `;


            selectEmpleadoIGSS.disabled =
                false;

        }

    }

}


// =====================================================
// CARGAR REGISTROS IGSS
//
// GET /igss/listar
//
// VIEW:
// dbo.LISTARIGSS
// =====================================================

async function cargarRegistrosIGSS() {

    try {

        if (!tbodyIGSS) {

            console.warn(
                "No se encontr� #tbodyIGSS"
            );

            return;

        }


        tbodyIGSS.innerHTML = `
            <tr>
                <td
                    colspan="11"
                    class="text-center py-4"
                >

                    <div
                        class="spinner-border spinner-border-sm text-success me-2"
                        role="status">
                    </div>

                    Cargando registros de IGSS...

                </td>
            </tr>
        `;


        const respuesta =
            await fetch(
                "/igss/listar"
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "RESPUESTA GET /igss/listar:",
            resultado
        );


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudieron cargar los registros de IGSS"
            );

        }


        registrosTablaIGSS =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        mostrarRegistrosIGSS(
            registrosTablaIGSS
        );


    } catch (error) {

        console.error(
            "ERROR AL CARGAR TABLA IGSS:",
            error
        );


        if (tbodyIGSS) {

            tbodyIGSS.innerHTML = `
                <tr>
                    <td
                        colspan="11"
                        class="text-center text-danger py-4"
                    >

                        Error al cargar los registros de IGSS

                    </td>
                </tr>
            `;

        }

    }

}


// =====================================================
// MOSTRAR REGISTROS IGSS
// =====================================================

function mostrarRegistrosIGSS(
    registros
) {

    if (!tbodyIGSS) {

        console.warn(
            "No existe #tbodyIGSS"
        );

        return;

    }


    tbodyIGSS.innerHTML = "";


    if (
        !Array.isArray(registros) ||
        registros.length === 0
    ) {

        tbodyIGSS.innerHTML = `
            <tr>

                <td
                    colspan="11"
                    class="text-center text-muted py-4"
                >

                    No existen registros de IGSS

                </td>

            </tr>
        `;


        actualizarResumenIGSS([]);


        return;

    }


    registros.forEach(
        (registro, indice) => {

            const tr =
                document.createElement(
                    "tr"
                );


            // =================================================
            // FECHA DE PAGO
            //
            // VIENE DESDE SQL SERVER
            //
            // NO SE CONVIERTE CON new Date()
            // =================================================

            const fecha =
                formatearFechaIGSS(
                    registro.FECHA
                );


            // =================================================
            // SALARIO BASE
            // =================================================

            const salarioBase =
                formatearMonedaIGSS(
                    registro.SALARIOBASE
                );


            // =================================================
            // IGSS
            // =================================================

            const igss =
                formatearNumeroIGSS(
                    registro.IGSS
                );


            // =================================================
            // PAGAR IGSS
            // =================================================

            const pagarIGSS =
                formatearMonedaIGSS(
                    registro.PAGARIGSS
                );


            // =================================================
            // ESTADO
            // =================================================

            const estado =
                String(
                    registro.ESTADO ?? ""
                ).toUpperCase();


            // =================================================
            // TEXTO ESTADO
            // =================================================

            const textoEstado =
                estado === "A"
                    ? "Activo"
                    : estado === "I"
                        ? "Inactivo"
                        : estado === "D"
                            ? "Eliminado"
                            : estado;


            // =================================================
            // CLASE ESTADO
            // =================================================

            const claseEstado =
                estado === "A"
                    ? "bg-success"
                    : "bg-secondary";


            // =================================================
            // BOT�N ELIMINAR
            // =================================================

            const botonEliminar =
                estado === "A"
                    ? `
                        <button
                            type="button"
                            class="btn btn-danger btn-sm btnEliminarIGSS"
                            data-id="${registro.IDEGRESOS}"
                            title="Eliminar IGSS"
                        >

                            <i class="bi bi-trash"></i>

                        </button>
                    `
                    : `
                        <button
                            type="button"
                            class="btn btn-secondary btn-sm"
                            disabled
                            title="Registro inactivo"
                        >

                            <i class="bi bi-trash"></i>

                        </button>
                    `;


            // =================================================
            // FILA
            // =================================================

            tr.innerHTML = `

                <td class="text-center">

                    ${indice + 1}

                </td>


                <td class="text-center">

                    ${fecha}

                </td>


                <td>

                    ${registro.NOMBREEMPLEADO ?? ""}

                </td>


                <td>

                    ${registro.DPI ?? ""}

                </td>


                <td>

                    ${registro.NOMBREPUESTO ?? ""}

                </td>


                <td>

                    ${registro.DIRECCION ?? ""}

                </td>


                <td class="text-end">

                    Q ${salarioBase}

                </td>


                <td class="text-center">

                    ${igss}%

                </td>


                <td class="text-end">

                    Q ${pagarIGSS}

                </td>


                <td class="text-center">

                    <span
                        class="badge ${claseEstado}"
                    >

                        ${textoEstado}

                    </span>

                </td>


                <td class="text-center">

                    ${botonEliminar}

                </td>

            `;


            tbodyIGSS.appendChild(
                tr
            );

        }
    );


    // =================================================
    // CONFIGURAR BOTONES ELIMINAR
    // =================================================

    configurarBotonesEliminarIGSS();


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    actualizarResumenIGSS(
        registros
    );

}


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

function actualizarResumenIGSS(
    registros
) {

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    const totalIGSS =
        document.getElementById(
            "totalIGSS"
        );


    const totalPagadoIGSS =
        document.getElementById(
            "totalPagadoIGSS"
        );


    if (totalEmpleados) {

        totalEmpleados.textContent =
            registros.length;

    }


    let sumaIGSS = 0;

    let sumaPagadoIGSS = 0;


    registros.forEach(
        registro => {

            const pagar =
                parseFloat(
                    registro.PAGARIGSS
                );


            if (!isNaN(pagar)) {

                sumaPagadoIGSS +=
                    pagar;

            }


            const igss =
                parseFloat(
                    registro.IGSS
                );


            if (!isNaN(igss)) {

                sumaIGSS +=
                    igss;

            }

        }
    );


    if (totalIGSS) {

        totalIGSS.textContent =
            `Q ${sumaIGSS.toFixed(2)}`;

    }


    if (totalPagadoIGSS) {

        totalPagadoIGSS.textContent =
            `Q ${sumaPagadoIGSS.toFixed(2)}`;

    }

}


// =====================================================
// CONFIGURAR BOTONES ELIMINAR
// =====================================================

function configurarBotonesEliminarIGSS() {

    const botones =
        document.querySelectorAll(
            ".btnEliminarIGSS"
        );


    botones.forEach(
        boton => {

            boton.addEventListener(
                "click",
                async function () {

                    // =========================================
                    // OBTENER IDEGRESOS
                    // =========================================

                    const idEgresos =
                        parseInt(
                            this.dataset.id,
                            10
                        );


                    // =========================================
                    // VALIDAR
                    // =========================================

                    if (
                        isNaN(idEgresos) ||
                        idEgresos <= 0
                    ) {

                        alert(
                            "El ID del registro no es v�lido"
                        );

                        return;

                    }


                    // =========================================
                    // EVITAR DOBLE CLICK
                    // =========================================

                    if (eliminandoIGSS) {

                        return;

                    }


                    // =========================================
                    // CONFIRMAR
                    // =========================================

                    const confirmar =
                        confirm(
                            "�Est� seguro de eliminar este registro de IGSS?"
                        );


                    if (!confirmar) {

                        return;

                    }


                    // =========================================
                    // ELIMINAR
                    // =========================================

                    await eliminarIGSS(
                        idEgresos,
                        this
                    );

                }
            );

        }
    );

}


// =====================================================
// ELIMINAR IGSS
//
// DELETE /igss/eliminar/:id
//
// :id = IDEGRESOS
// =====================================================

async function eliminarIGSS(
    idEgresos,
    boton = null
) {

    if (eliminandoIGSS) {

        return;

    }


    try {

        eliminandoIGSS = true;


        // =================================================
        // DESHABILITAR BOT�N
        // =================================================

        if (boton) {

            boton.disabled = true;


            boton.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm"
                    role="status">
                </span>
            `;

        }


        // =================================================
        // PETICI�N DELETE
        // =================================================

        const respuesta =
            await fetch(
                `/igss/eliminar/${idEgresos}`,
                {
                    method: "DELETE"
                }
            );


        // =================================================
        // LEER RESPUESTA
        // =================================================

        let resultado = {};


        try {

            resultado =
                await respuesta.json();

        } catch (errorJSON) {

            console.warn(
                "La respuesta del servidor no contiene JSON v�lido"
            );

        }


        console.log(
            "RESPUESTA DELETE IGSS:",
            resultado
        );


        // =================================================
        // VALIDAR RESPUESTA
        // =================================================

        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                `Error HTTP ${respuesta.status}`
            );

        }


        // =================================================
        // MENSAJE
        // =================================================

        alert(
            resultado.mensaje ||
            "Registro de IGSS eliminado correctamente"
        );


        // =================================================
        // RECARGAR TABLA
        // =================================================

        await cargarRegistrosIGSS();


    } catch (error) {

        console.error(
            "ERROR AL ELIMINAR IGSS:",
            error
        );


        alert(
            error.message ||
            "Error al eliminar el registro de IGSS"
        );


    } finally {

        eliminandoIGSS = false;


        if (boton) {

            boton.disabled = false;


            boton.innerHTML = `
                <i class="bi bi-trash"></i>
            `;

        }

    }

}


// =====================================================
// FORMATEAR FECHA
//
// IMPORTANTE:
// -----------------------------------------------------
// SQL Server puede devolver:
//
// 2026-10-03T20:41:51.883Z
//
// o:
//
// 2026-10-03T20:41:51.883
//
// o:
//
// 2026-10-03 20:41:51
//
// NO utilizar:
//
// new Date(fecha)
//
// porque JavaScript puede convertir la fecha a otra
// zona horaria y mostrar el d�a anterior.
//
// Se toma directamente:
//
// YYYY-MM-DD
//
// y se muestra:
//
// DD/MM/YYYY
// =====================================================

function formatearFechaIGSS(
    fecha
) {

    if (
        fecha === null ||
        fecha === undefined ||
        fecha === ""
    ) {

        return "";

    }


    try {

        const textoFecha =
            String(
                fecha
            ).trim();


        // =================================================
        // EXTRAER A�O, MES Y D�A DIRECTAMENTE
        // =================================================

        const coincidencia =
            textoFecha.match(
                /^(\d{4})-(\d{2})-(\d{2})/
            );


        if (coincidencia) {

            const anio =
                coincidencia[1];


            const mes =
                coincidencia[2];


            const dia =
                coincidencia[3];


            return `${dia}/${mes}/${anio}`;

        }


        // =================================================
        // SOPORTE PARA FORMATO:
        //
        // DD/MM/YYYY
        // =================================================

        const coincidenciaLatina =
            textoFecha.match(
                /^(\d{2})\/(\d{2})\/(\d{4})/
            );


        if (coincidenciaLatina) {

            return textoFecha;

        }


        // =================================================
        // SI NO SE PUEDE RECONOCER
        // =================================================

        return textoFecha;


    } catch (error) {

        console.error(
            "ERROR AL FORMATEAR FECHA IGSS:",
            error
        );


        return String(
            fecha
        );

    }

}


// =====================================================
// FORMATEAR MONEDA
// =====================================================

function formatearMonedaIGSS(
    valor
) {

    const numero =
        parseFloat(
            valor
        );


    if (
        isNaN(numero)
    ) {

        return "0.00";

    }


    return numero.toFixed(2);

}


// =====================================================
// FORMATEAR N�MERO
// =====================================================

function formatearNumeroIGSS(
    valor
) {

    const numero =
        parseFloat(
            valor
        );


    if (
        isNaN(numero)
    ) {

        return "0.00";

    }


    return numero.toFixed(2);

}


// =====================================================
// FILTRAR TABLA
// =====================================================

function filtrarTablaIGSS() {

    if (!buscarIGSS) {

        return;

    }


    const texto =
        buscarIGSS.value
            .toLowerCase()
            .trim();


    if (!texto) {

        mostrarRegistrosIGSS(
            registrosTablaIGSS
        );

        return;

    }


    const registrosFiltrados =
        registrosTablaIGSS.filter(
            registro => {

                return (

                    String(
                        registro.IDEGRESOS ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.FECHA ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.NOMBREEMPLEADO ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.DPI ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.NOMBREPUESTO ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.DIRECCION ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.SALARIOBASE ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.IGSS ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.PAGARIGSS ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                    ||

                    String(
                        registro.ESTADO ?? ""
                    )
                        .toLowerCase()
                        .includes(texto)

                );

            }
        );


    mostrarRegistrosIGSS(
        registrosFiltrados
    );

}


// =====================================================
// SELECCIONAR EMPLEADO
// =====================================================

async function seleccionarEmpleadoIGSS() {

    try {

        if (!selectEmpleadoIGSS) {

            return;

        }


        const idEmpleado =
            selectEmpleadoIGSS.value;


        if (!idEmpleado) {

            empleadoSeleccionadoIGSS =
                null;


            limpiarCamposIGSS();


            return;

        }


        const empleado =
            registrosigss.find(
                item =>
                    String(
                        item.IDEMPLEADO
                    ) ===
                    String(
                        idEmpleado
                    )
            );


        if (empleado) {

            empleadoSeleccionadoIGSS =
                empleado;


            llenarCamposIGSS(
                empleado
            );


            return;

        }


        const respuesta =
            await fetch(
                `/igss/empleado/${idEmpleado}`
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se encontr� el empleado"
            );

        }


        empleadoSeleccionadoIGSS =
            resultado.data;


        llenarCamposIGSS(
            resultado.data
        );


    } catch (error) {

        console.error(
            "Error al seleccionar empleado IGSS:",
            error
        );


        limpiarCamposIGSS();

    }

}


// =====================================================
// LLENAR CAMPOS
// =====================================================

function llenarCamposIGSS(
    empleado
) {

    if (!empleado) {

        return;

    }


    if (idEmpleadoIGSS) {

        idEmpleadoIGSS.value =
            empleado.IDEMPLEADO ?? "";

    }


    if (nombreEmpleadoIGSS) {

        nombreEmpleadoIGSS.value =
            empleado.NOMBREEMPLEADO ?? "";

    }


    if (dpiIGSS) {

        dpiIGSS.value =
            empleado.DPI ?? "";

    }


    if (nombrePuestoIGSS) {

        nombrePuestoIGSS.value =
            empleado.NOMBREPUESTO ?? "";

    }


    if (direccionIGSS) {

        direccionIGSS.value =
            empleado.DIRECCION ?? "";

    }


    if (salarioBaseIGSS) {

        salarioBaseIGSS.value =
            empleado.SALARIOBASE ?? "";

    }


    if (porcentajeIGSS) {

        porcentajeIGSS.value =
            PORCENTAJE_IGSS.toFixed(2);

    }


    // =================================================
    // MANTENER FECHA ACTUAL
    // =================================================

    colocarFechaActualIGSS();


    calcularIGSS();


    console.log(
        "Empleado seleccionado:",
        empleado
    );

}


// =====================================================
// CALCULAR IGSS
//
// SALARIO BASE � 4.83 � 100
// =====================================================

function calcularIGSS() {

    if (!salarioBaseIGSS) {

        return 0;

    }


    let salario =
        parseFloat(
            salarioBaseIGSS.value
        );


    if (
        isNaN(salario)
    ) {

        salario = 0;

    }


    const porcentaje =
        PORCENTAJE_IGSS;


    const montoIGSS =
        salario *
        porcentaje /
        100;


    if (porcentajeIGSS) {

        porcentajeIGSS.value =
            PORCENTAJE_IGSS.toFixed(2);

    }


    if (sueldoPagadoIGSS) {

        sueldoPagadoIGSS.value =
            montoIGSS.toFixed(2);

    }


    console.log(
        "C�LCULO IGSS:",
        `${salario} � ${porcentaje} � 100 = ${montoIGSS.toFixed(2)}`
    );


    return montoIGSS;

}


// =====================================================
// GUARDAR IGSS
//
// POST /igss/guardar
//
// FECHA:
// -----------------------------------------------------
// NO SE ENV�A DESDE JAVASCRIPT.
//
// SQL SERVER DEBE COLOCAR:
//
// GETDATE()
//
// EN LA COLUMNA FECHA.
// =====================================================

async function guardarIGSS() {

    if (guardandoIGSS) {

        return;

    }


    try {

        // =================================================
        // VALIDAR EMPLEADO
        // =================================================

        if (!empleadoSeleccionadoIGSS) {

            alert(
                "Seleccione un empleado"
            );

            return;

        }


        // =================================================
        // ID EMPLEADO
        // =================================================

        const idEmpleado =
            parseInt(
                empleadoSeleccionadoIGSS.IDEMPLEADO,
                10
            );


        if (
            isNaN(idEmpleado) ||
            idEmpleado <= 0
        ) {

            alert(
                "El ID del empleado no es v�lido"
            );

            return;

        }


        // =================================================
        // CALCULAR IGSS
        // =================================================

        const montoIGSS =
            calcularIGSS();


        if (
            isNaN(montoIGSS) ||
            montoIGSS < 0
        ) {

            alert(
                "El monto de IGSS no es v�lido"
            );

            return;

        }


        // =================================================
        // PORCENTAJE
        // =================================================

        const igss =
            PORCENTAJE_IGSS;


        // =================================================
        // PAGAR IGSS
        // =================================================

        const pagarIGSS =
            Number(
                montoIGSS.toFixed(2)
            );


        // =================================================
        // ACTIVAR BLOQUEO
        // =================================================

        guardandoIGSS = true;


        // =================================================
        // BOT�N GUARDAR
        // =================================================

        const btnGuardarIGSS =
            document.getElementById(
                "btnGuardarIGSS"
            );


        if (btnGuardarIGSS) {

            btnGuardarIGSS.disabled =
                true;


            btnGuardarIGSS.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status">
                </span>

                Guardando...
            `;

        }


        // =================================================
        // PETICI�N AL SERVIDOR
        //
        // IMPORTANTE:
        //
        // NO enviamos FECHA.
        //
        // SQL SERVER LA GENERA CON GETDATE().
        // =================================================

        const respuesta =
            await fetch(
                "/igss/guardar",
                {
                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json"

                    },

                    body: JSON.stringify({

                        idEmpleado:
                            idEmpleado,

                        igss:
                            igss,

                        pagarIGSS:
                            pagarIGSS

                    })

                }
            );


        // =================================================
        // LEER RESPUESTA
        // =================================================

        let resultado = {};


        try {

            resultado =
                await respuesta.json();

        } catch (errorJSON) {

            console.error(
                "Respuesta inv�lida del servidor:",
                errorJSON
            );

        }


        console.log(
            "RESPUESTA GUARDAR IGSS:",
            resultado
        );


        // =================================================
        // VALIDAR RESPUESTA
        // =================================================

        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo guardar el IGSS"
            );

        }


        // =================================================
        // MENSAJE
        // =================================================

        alert(
            resultado.mensaje ||
            "IGSS guardado correctamente"
        );


        // =================================================
        // CERRAR MODAL
        // =================================================

        const modalElemento =
            document.getElementById(
                "modalIGSS"
            );


        if (modalElemento) {

            const modal =
                bootstrap.Modal.getInstance(
                    modalElemento
                );


            if (modal) {

                modal.hide();

            }

        }


        // =================================================
        // LIMPIAR SELECCI�N
        // =================================================

        empleadoSeleccionadoIGSS =
            null;


        limpiarCamposIGSS();


        if (selectEmpleadoIGSS) {

            selectEmpleadoIGSS.value =
                "";

        }


        // =================================================
        // RECARGAR TABLA
        //
        // SQL SERVER DEVUELVE LA FECHA REAL
        // QUE REGISTR� CON GETDATE().
        // =================================================

        await cargarRegistrosIGSS();


    } catch (error) {

        console.error(
            "ERROR AL GUARDAR IGSS:",
            error
        );


        alert(
            error.message ||
            "Error al guardar el IGSS"
        );


    } finally {

        guardandoIGSS = false;


        const btnGuardarIGSS =
            document.getElementById(
                "btnGuardarIGSS"
            );


        if (btnGuardarIGSS) {

            btnGuardarIGSS.disabled =
                false;


            btnGuardarIGSS.innerHTML = `
                <i class="bi bi-save me-1"></i>
                Guardar IGSS
            `;

        }

    }

}


// =====================================================
// LIMPIAR CAMPOS
// =====================================================

function limpiarCamposIGSS() {

    if (idEmpleadoIGSS) {

        idEmpleadoIGSS.value = "";

    }


    if (nombreEmpleadoIGSS) {

        nombreEmpleadoIGSS.value = "";

    }


    if (dpiIGSS) {

        dpiIGSS.value = "";

    }


    if (nombrePuestoIGSS) {

        nombrePuestoIGSS.value = "";

    }


    if (direccionIGSS) {

        direccionIGSS.value = "";

    }


    if (salarioBaseIGSS) {

        salarioBaseIGSS.value = "";

    }


    if (porcentajeIGSS) {

        porcentajeIGSS.value =
            PORCENTAJE_IGSS.toFixed(2);

    }


    if (sueldoPagadoIGSS) {

        sueldoPagadoIGSS.value = "";

    }


    // =================================================
    // RESTABLECER FECHA ACTUAL
    // =================================================

    colocarFechaActualIGSS();

}


// =====================================================
// OBTENER EMPLEADO SELECCIONADO
// =====================================================

function obtenerEmpleadoSeleccionadoIGSS() {

    return empleadoSeleccionadoIGSS;

}


// =====================================================
// RECARGAR EMPLEADOS
// =====================================================

async function recargarEmpleadosIGSS() {

    empleadoSeleccionadoIGSS =
        null;


    limpiarCamposIGSS();


    await cargarEmpleadosIGSS();

}


// =====================================================
// RECARGAR TABLA
// =====================================================

async function recargarTablaIGSS() {

    await cargarRegistrosIGSS();

}


// =====================================================
// BOT�N NUEVO
// =====================================================

function configurarBotonNuevoIGSS() {

    const btnNuevoIGSS =
        document.getElementById(
            "btnNuevoIGSS"
        );


    const modalElemento =
        document.getElementById(
            "modalIGSS"
        );


    if (!modalElemento) {

        console.warn(
            "No se encontr� #modalIGSS"
        );

        return;

    }


    const modalIGSS =
        bootstrap.Modal.getOrCreateInstance(
            modalElemento
        );


    if (btnNuevoIGSS) {

        btnNuevoIGSS.addEventListener(
            "click",
            function () {

                empleadoSeleccionadoIGSS =
                    null;


                limpiarCamposIGSS();


                if (selectEmpleadoIGSS) {

                    selectEmpleadoIGSS.value =
                        "";

                }


                if (porcentajeIGSS) {

                    porcentajeIGSS.value =
                        PORCENTAJE_IGSS.toFixed(2);

                }


                // =================================================
                // FECHA AUTOM�TICA AL ABRIR NUEVO
                // =================================================

                colocarFechaActualIGSS();


                modalIGSS.show();

            }
        );

    }

}


// =====================================================
// BOT�N GUARDAR
// =====================================================

function configurarBotonGuardarIGSS() {

    const btnGuardarIGSS =
        document.getElementById(
            "btnGuardarIGSS"
        );


    if (!btnGuardarIGSS) {

        console.warn(
            "No se encontr� #btnGuardarIGSS"
        );

        return;

    }


    btnGuardarIGSS.addEventListener(
        "click",
        guardarIGSS
    );

}


// =====================================================
// INICIAR M�DULO
// =====================================================

async function iniciarModuloIGSS() {

    await inicializarIGSS();


    configurarBotonNuevoIGSS();


    configurarBotonGuardarIGSS();

}


// =====================================================
// DOM READY
// =====================================================

if (
    document.readyState ===
    "loading"
) {

    document.addEventListener(
        "DOMContentLoaded",
        iniciarModuloIGSS
    );

} else {

    iniciarModuloIGSS();

}
